import React from "react";
import { FileObject } from "material-ui-dropzone";
import { SpecialZoomLevel, Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { Box, Button } from "@material-ui/core";

type Props = {
    file: FileObject;
    replace: () => any;
};

const Screen2: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (
    { file, replace },
    ref
) => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    return (
        <React.Fragment>
            <Box
                component="div"
                paddingX={2}
                paddingY={3}
                marginTop={6}
                marginBottom={3}
                bgcolor={"#f7f7f7"}
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <strong>{file.file.name}</strong>
                <Button variant="outlined" onClick={replace}>
                    Replace Document
                </Button>
            </Box>
            <div ref={ref}>
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                    <Viewer
                        fileUrl={file.data as string}
                        defaultScale={SpecialZoomLevel.PageWidth}
                    />
                </Worker>
            </div>
        </React.Fragment>
    );
};

export default React.forwardRef(Screen2);
